export function CleanCode(props: {
    code: string,
    attributes: {style: any, className: string, 'builder-id': string, id: string}
  }) {
  
    return (
        <div style={props.attributes.style} className={props.attributes.className} builder-id={props.attributes['builder-id']} id={props.attributes.id} dangerouslySetInnerHTML={{ __html: props.code }} />
    )
  }
